<div class="info-page">
  <h3>PROAS</h3>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Nº do Processo </th>
          <th>Assunto</th>
          <th>Atividade Atual</th>
          <th>Data de Recebimento</th>
          <th>Órgão/Grupo origem Atividade</th>
          <th>Órgão/Grupo origem Portador</th>
         <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of lista; let i = index">
          <tr>
            <td class="title">
                {{onMaskProcesso(item.numero_processo)}}
              <div class="responsavel">
                <div *ngIf="item.estrategico" class="tag">Estratégico</div>
                <div *ngIf="item.privado" class="tag irfe">Privado</div>
              </div>
            </td>

            <td *ngIf="item.erro; else semErros" colspan="6">
              {{ item.erro }}
            </td>

            <ng-template #semErros>
              <td>{{ item.tipo_processo }}</td>
              <td>{{ item.atividade_atual }}</td>
              <td>
                <div class="m-b-xs">
                  {{item.data_recebimento}}
                </div>
                <strong>há {{item.data_recebimento_dias}} dias</strong>
              </td>
              <td>
                {{ item.orgao_origem }}
              </td>
              <td>
                {{item?.orgao_portador}}
              </td>
              <td>
                <div class="btn-icon">
                  <button class="btn btn-white font-icon" (click)="verSituacaoClickHandler(i)"
                    title="{{showSituacao[i]? 'Fechar':'Abrir'}} descrição">{{showSituacao[i]? 'zoom_out': 'zoom_in'}}</button>
                  <a class="btn btn-white font-icon ms-1" *ngIf="item.route" title="Abrir processo"
                    href="{{item.route}}" target="_blank" >open_in_new</a>
                </div>
              </td>
            </ng-template>
          </tr>

          <tr *ngIf="showSituacao[i]">
            <td class="title">
              <strong>Descrição:</strong>
            </td>
            <td class="text-left" colspan="6">
              {{ item?.descricao ?? "Sem Descrição" }}
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!lista?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhum PROA Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>